import React from 'react';

// Phone-tight on mobile, scales up to ~2x on tablet/desktop.
const CIRCLE_BASE = 'relative w-16 h-16 sm:w-20 sm:h-20 md:w-32 md:h-32 lg:w-36 lg:h-36 text-base sm:text-lg md:text-2xl lg:text-3xl rounded-full flex flex-col items-center justify-center font-bold transition-all duration-150 active:scale-95 select-none disabled:opacity-40 disabled:pointer-events-none';

const TONES = {
  made:    'bg-[#0F1A4A] text-emerald-300 border-2 border-emerald-400/80 shadow-[0_0_18px_rgba(52,211,153,0.18)] hover:border-emerald-300',
  miss:    'bg-[#0F1A4A] text-rose-300 border-2 border-rose-400/70 shadow-[0_0_18px_rgba(244,63,94,0.18)] hover:border-rose-300',
  neutral: 'bg-[#0F1A4A] text-white border-2 border-white/40 hover:border-white/80',
  danger:  'bg-[#0F1A4A] text-rose-300 border-2 border-rose-400/60 hover:border-rose-300',
};

export function CircleBtn({ children, onClick, tone = 'neutral', testId, ariaLabel, disabled }) {
  return (
    <button type="button" onClick={onClick} disabled={disabled}
      aria-label={ariaLabel} data-testid={testId}
      className={`${CIRCLE_BASE} ${TONES[tone] || TONES.neutral}`}>
      {children}
    </button>
  );
}

export function PillBtn({ children, onClick, tone = 'neutral', testId, ariaLabel }) {
  const tone_ = tone === 'danger' ? TONES.danger : TONES.neutral;
  return (
    <button type="button" onClick={onClick}
      aria-label={ariaLabel} data-testid={testId}
      className={`px-5 py-2.5 md:px-8 md:py-4 lg:px-10 lg:py-5 rounded-full font-semibold text-sm md:text-lg lg:text-xl transition-all active:scale-95 ${tone_}`}>
      {children}
    </button>
  );
}
